import { UNSAFE_noExposureExp } from '@confluence/feature-experiments';

export const INVITE_ON_PAGE_PUBLISH_EXPERIMENT_KEY = 'invite_on_page_publish';

export const INVITE_ON_PAGE_PUBLISH_GATE_KEY = 'invite_on_page_publish_gate';

export const NOT_ENROLLED = 'not-enrolled';
export const VARIATION = 'variation';
export const CONTROL = 'control';

export const getExperimentCohort = ({ fireExposure } = { fireExposure: false }) => {
	try {
		const [expConfig, fireExperimentExposure] = UNSAFE_noExposureExp('invite_on_page_publish');
		fireExposure && fireExperimentExposure();
		return expConfig.get('cohort', 'not-enrolled');
	} catch {
		return NOT_ENROLLED;
	}
};

export const isExperimentEnabled = () => getExperimentCohort({ fireExposure: false }) === VARIATION;
